module.exports = __webpack_public_path__ + "static/media/ProximaNova-RegIt.96b34dd3.otf";